module.exports = __webpack_public_path__ + "32f2a5d70f624c6d305f3794ec226a64.png";